import React from 'react';
import { inject, observer } from 'mobx-react';

import './index.scss';

import CircularProgress from '@material-ui/core/CircularProgress';

import CustomSnackbar from '../../../components/global/snackbar'
import CustomTabs from '../../../components/basic/customTabs';
import CustomInput from '../../../components/basic/input'
import CustomButton from '../../../components/basic/CustomButton'
import Box from '../../../components/basic/box'
import CustomTableSimple from '../../../components/complex/customTableSimple'
import CustomAvatar from '../../../components/basic/customAvatar'
import BoxClients from '../../../components/basic/boxClients'

import { api } from '../../../functions/api'
import { toJS } from 'mobx';

const TIMEOUT = 3000;


@inject('internal')
@inject('translate')
@observer
export default class AdministratorsEdit extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            passwordIsOk: false,
            loading: false,
            openSnackbar: false,
            message: "",
            loadingBtn: false
        }
    }

    tabsConfig = [
        // {
        //     label: this.props.translate.i18n.MODULES.ADMINISTRATORS.TABS.BASIC_INFO,
        //     url: "/administrators/edit/tab=/0"
        // },
        // {
        //     label: this.props.translate.i18n.MODULES.ADMINISTRATORS.TABS.PASSWORD,
        //     url: "/administrators/edit/tab=/1",
        //     admin: true
        // },

        // {
        //     label: this.props.translate.i18n.MODULES.ADMINISTRATORS.TABS.CLIENTS,
        //     url: "/administrators/edit/tab=/2"
        // }
    ]


    componentDidMount() {
        if(toJS(this.props.internal.user)
            && toJS(this.props.internal.user.data)
            && toJS(this.props.internal.user.data.permissions)
            && toJS(this.props.internal.user.data.permissions.administrators)
            && toJS(this.props.internal.user.data.permissions.administrators.view)){

            this.setPermissions();
            this.getBasicInfoAboutAdmin();
            this.props.internal.setRoute(this.props.history, this.props.location.pathname)
        }
        else {
            this.props.internal.setRoute( this.props.history, this.props.location.pathname)
            this.props.internal.pushRoute('/')
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_PERMISSIONS, true)
        }
    }

    timeout = null;
    componentWillUnmount() {
        clearTimeout(this.timeout)
    }

    updateMineClients = async () => {
        var ids = this.props.internal.dataForSimpeTable.clients_list['mine'].map(obj => obj.id);

        let update_data = await api({
            method: 'patch',
            //url: 'administrators/' + this.props.match.params.idAdmin + "/clients-pair",
            url: 'administrators/' + this.props.internal.dataForSimpeTable.id + "/clients-pair",
            authorization: this.props.internal.user.access_token,
            params: {
                ids: ids
            }
        })

        if (update_data.success === true) {
            this.setState({ message: update_data.data.message, openSnackbar: true })
            //this.getBasicInfoAboutAdmin();
        }
        this.closeSnackBar();
    }

    closeSnackBar() {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.setState({ message: "", openSnackbar: false })
        }, TIMEOUT)
    }

    labels = [
        {
            label: "first_name",
            value: this.props.translate.i18n.GLOBAL.USER.FIRST_NAME,
        },
        {
            label: "last_name",
            value: this.props.translate.i18n.GLOBAL.USER.LAST_NAME,
        },
        {
            label: "email",
            value: this.props.translate.i18n.GLOBAL.CONTACT.EMAIL,
        },
        {
            label: "alternate_email",
            value: this.props.translate.i18n.GLOBAL.CONTACT.ALTERNATE_EMAIL,
            disabled: true
        },
        {
            label: "phone",
            value: this.props.translate.i18n.GLOBAL.CONTACT.PHONE,
        },
        {
            label: "fax",
            value: this.props.translate.i18n.GLOBAL.CONTACT.FAX,
        },
        {
            label: "available",
            value: this.props.translate.i18n.MODULES.ADMINISTRATORS.AVAILABLE,
        },
        // {
        //     label: "is_representative",
        //     value: this.props.translate.i18n.MODULES.ADMINISTRATORS.ADMIN_ROLE
        // }
    ];

    setPermissions = () => {
        this.tabsConfig.push(
            {
                label: this.props.translate.i18n.MODULES.ADMINISTRATORS.TABS.BASIC_INFO,
                url: "/administrators/edit/tab=/0"
            },
        )
        let idLoggedAdmin = toJS(this.props.internal.user.data.id);
        let idAdminDetails = Number(this.props.match.params.idAdmin);
        if(idLoggedAdmin === idAdminDetails) {
            this.tabsConfig.push(
                {
                    label: this.props.translate.i18n.MODULES.ADMINISTRATORS.TABS.PASSWORD,
                    url: "/administrators/edit/tab=/1",
                    admin: true
                },
                {
                    label: this.props.translate.i18n.MODULES.ADMINISTRATORS.TABS.CLIENTS,
                    url: "/administrators/edit/tab=/2"
                }
            )
        }
        else {
            this.tabsConfig.push(
                {
                    label: this.props.translate.i18n.MODULES.ADMINISTRATORS.TABS.CLIENTS,
                    url: "/administrators/edit/tab=/1"
                }
            )
        }

        let editAdminPribilege = toJS(this.props.internal.user.data.role.id) < 3;
        if(editAdminPribilege) {
            this.labels.push(
                {
                    label: "is_representative",
                    value: this.props.translate.i18n.MODULES.ADMINISTRATORS.ADMIN_ROLE
                }
            )
        }
        
    }

    getBasicInfoAboutAdmin = async () => {
        this.setState({ loading: true })

        let load_data = await api({
            method: 'get',
            url: 'administrators/' + this.props.match.params.idAdmin,
            authorization: this.props.internal.user.access_token,
        })

        if (load_data.success && load_data.success === true) {
            let data = load_data.data.data.data
            delete load_data.data.data.data;
            let obj = Object.assign(load_data.data.data, data)

            //this.props.internal.setOneAdministrator(obj);
            this.props.internal.setDataForSimpeTable(obj);

            this.setState({ loading: false })
        }
    }

    updateClientData = async () => {
        let dataForUpdate = {
            data: {},
        }

        for (let prop in this.labels) {
            let label = this.labels[prop].label
            let data = toJS(this.props.internal.dataForSimpeTable)
            if (label === "phone" || label === "fax" || label === "alternate_email") {
                dataForUpdate.data[label] = data[label]
            }
            else {
                dataForUpdate[label] = data[label]
            }
        }
        this.props.internal.updateUser(dataForUpdate)

        let load_data = await api({
            method: 'patch',
            //method: 'post',
            url: 'user',
            authorization: this.props.internal.user.access_token,
            //formData: true,
            params: dataForUpdate,
            //_method: "patch"
        })

        if (load_data.success && load_data.success === true) {
            // this.setState({ message: load_data.data.message, openSnackbar: true })
            this.props.internal.setSnackbar(load_data.data.message, true)
        }
        else {
            let resultError = ""
            if(load_data.data.data.errors) {
                for(let error in load_data.data.data.errors){
                    resultError += load_data.data.data.errors[error] + " "
                }
            }
            
            this.props.internal.setSnackbar(resultError, true)
        }
        
        this.closeSnackBar();
    }


    handleCloseSnackbar = () => {
        this.setState({ openSnackbar: false });
    };

    handleChangePhoto = async (data) => {
        let upload_data = await api({
            method: 'post',
            // method: "patch",
            url: 'user',
            formData: true,
            authorization: this.props.internal.user.access_token,
            params: {
                //photo: formData
                photo: data
            },
            //_method: "patch"

        })
        
        this.closeSnackBar();
        if (upload_data.success && upload_data.success === true) {

            // this.getBasicInfoAboutAdmin();
            // this.setState({message: upload_data.data.message, openSnackbar: true})
            this.props.internal.setSnackbar(upload_data.data.message, true)
            // this.props.internal.photoWasChanged(null)
            return Promise.resolve(false)
        }
        
    }
    

    handleChangePassword = async () => {
        this.setState({loadingBtn: true})

        if(this.inputPassword.state.value === "" || this.inputPassword1.state.value === "" || this.inputPassword2.state.value === "") {
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_FILL_ALL_INPUTS, true);
        }
        else {
            let change_password = await api({
                method: 'patch',
                url: 'user',
                authorization: this.props.internal.user.access_token,
                params: {
                    current_password: this.inputPassword.state.value,
                    password: this.inputPassword1.state.value,
                    password_confirmation: this.inputPassword2.state.value
                }
            })

            if(change_password.success === true) {
                this.setState({message: change_password.data.message, openSnackbar: true})
                this.closeSnackBar();
                this.inputPassword.state.value = ""
                this.inputPassword1.state.value = ""
                this.inputPassword2.state.value = ""
            }
            else {
                let resultError = ""
                if(change_password.data.data.errors) {
                    for(let error in change_password.data.data.errors){
                        resultError += change_password.data.data.errors[error] + " "
                    }
                }
                this.setState({message: resultError, openSnackbar: true})
                this.closeSnackBar();
            }
        }
        this.setState({loadingBtn: false})
    }

    setIsRepresentative = (data) => {
        this.updateAdminPrivilege(data)
    }

    updateAdminPrivilege = async (roleId) => {
        let adminId = this.props.match.params.idAdmin
        let update_privilege = await api({
            method: 'patch',
            url: `administrators/${adminId}/role`,
            authorization: this.props.internal.user.access_token,
            params: {
                role_id: roleId
            }
        })

        if(update_privilege.success === true) {
            this.props.internal.setSnackbar(update_privilege.data.message, true)
        }
    }

    render() {
        const routerData = {
            history: this.props.history,
            location: this.props.location,
            match: this.props.match
        }

        let idAdmin = Number(routerData.match.params.idAdmin);
        let loggedUserId = Number(toJS(this.props.internal.user.data.id));

        return (
            <div className={'editAdmin-box'}>
                <CustomSnackbar message={this.state.message} open={this.state.openSnackbar} onClose={this.handleCloseSnackbar} value={this.state.searchTerm ?this.state.searchTerm : null }/>

                <CustomTabs
                    title={this.props.translate.i18n.MODULES.ADMINISTRATORS.TABS.TITLE}
                    //tabsConfig={idAdmin === loggedUserId ? this.tabsConfig : this.tabsConfigUser }
                    tabsConfig={this.tabsConfig}
                    routerData={routerData}
                    module={'/administrators'}>

                    {this.state.loading ?
                        <CircularProgress className={'circular-progress'} />
                        :
                        <div className={'about-admin'}>
                            <CustomAvatar
                                src={this.props.internal.dataForSimpeTable.photo}
                                disableEdit={idAdmin !== loggedUserId}
                                actionUploadPhoto={this.handleChangePhoto}
                            />
                            <CustomTableSimple
                                updateClientData={this.updateClientData}
                                className={'w-100 m-3 ml-20 th-bold'}
                                labels={this.labels}
                                disableEdit={idAdmin !== loggedUserId}
                                setIsRepresentative={this.setIsRepresentative}
                            />
                        </div>}
                    {idAdmin === loggedUserId ?
                        <div className={`reset-password`}>
                            <Box >
                                <h5>{this.props.translate.i18n.MODULES.ADMINISTRATORS.TABS.PASSWORD_TAB.TITLE}</h5>
                                <CustomInput
                                    //regex={regexes.password}
                                    ref={ref => this.inputPassword = ref}
                                    type={'password'}
                                    text={this.props.translate.i18n.MODULES.ADMINISTRATORS.TABS.PASSWORD_TAB.OLD_PASSWORD}
                                    //isValid={this.state.passwordIsOk}
                                    id={'password-1'}
                                    pressedButton
                                    onPressButton={this.handleChangePassword}
                                />
                                <CustomInput
                                    //regex={regexes.password}
                                    ref={ref => this.inputPassword1 = ref}
                                    type={'password'}
                                    text={this.props.translate.i18n.MODULES.ADMINISTRATORS.TABS.PASSWORD_TAB.NEW_PASSWORD}
                                    //isValid={this.state.passwordIsOk}
                                    id={'password-2'}
                                    pressedButton
                                    onPressButton={this.handleChangePassword}
                                />
                                <CustomInput
                                    //regex={regexes.password}
                                    ref={ref => this.inputPassword2 = ref}
                                    type={'password'}
                                    text={this.props.translate.i18n.MODULES.ADMINISTRATORS.TABS.PASSWORD_TAB.REPEAT_NEW_PASSWORD}
                                    //isValid={this.state.passwordIsOk}
                                    id={'password-3'}
                                    pressedButton
                                    onPressButton={this.handleChangePassword}
                                />
                                <br />
                                <CustomButton
                                    // className={'w-50'}
                                    justText
                                    progressBar={this.state.loadingBtn}
                                    onClick={this.handleChangePassword}
                                    mystyle={'btn-orange-bg w-50 align-self-end'}
                                    title={this.props.translate.i18n.MODULES.ADMINISTRATORS.TABS.PASSWORD_TAB.RESET_PASSWORD}
                                    pressButton
                                />
                            </Box>
                        </div>
                        :
                        this.state.loading ?
                        <CircularProgress className={'circular-progress'} />
                        :
                        <div className={'clients-boxes'}>

                            <BoxClients title={this.props.translate.i18n.MODULES.ADMINISTRATORS.TABS.CLIENTS_TAB.MINE} data={this.props.internal.dataForSimpeTable.clients_list} property="mine" checked update={this.updateMineClients} />

                            <BoxClients title={this.props.translate.i18n.MODULES.ADMINISTRATORS.TABS.CLIENTS_TAB.OTHER} data={this.props.internal.dataForSimpeTable.clients_list} property="other" update={this.updateMineClients} />
                        </div>
                    }
                    {this.state.loading ?
                        <CircularProgress className={'circular-progress'} />
                        :
                        <div className={'clients-boxes'}>

                            <BoxClients title={this.props.translate.i18n.MODULES.ADMINISTRATORS.TABS.CLIENTS_TAB.MINE} data={this.props.internal.dataForSimpeTable.clients_list} property="mine" checked update={this.updateMineClients} />

                            <BoxClients title={this.props.translate.i18n.MODULES.ADMINISTRATORS.TABS.CLIENTS_TAB.OTHER} data={this.props.internal.dataForSimpeTable.clients_list} property="other" update={this.updateMineClients} />
                        </div>
                    }

                </CustomTabs>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/administrators/edit/index.jsx